import { Flexbox } from '@morressier/ts';
import EmptyUserEventsIcon from './EmptyUserEventsIcon';
import {
  EmptyUserEventContainer,
  EmptyUserEventTitle,
  EmptyUserEventTitleContainer
} from './style';

const EmptyUserEventsState = () => {
  const text = 'You are not attending OR hosting any Events';
  return (
    <EmptyUserEventContainer>
      <Flexbox flexDirection="row">
        <EmptyUserEventsIcon />
        <EmptyUserEventTitleContainer>
          <EmptyUserEventTitle>{text}</EmptyUserEventTitle>
        </EmptyUserEventTitleContainer>
      </Flexbox>
    </EmptyUserEventContainer>
  );
};

export default EmptyUserEventsState;
